/* import __COLOCATED_TEMPLATE__ from './chrome.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();